var onboard = {};

import checklist, {} from 'packs/onboard/checklist.js';
onboard.checklist = checklist;

import tooltips, {} from 'packs/onboard/tooltips.js';
onboard.tooltips = tooltips;

export default onboard;